import { render, staticRenderFns } from "./RichWorkspace.vue?vue&type=template&id=7e06b1ea&scoped=true&"
import script from "./RichWorkspace.vue?vue&type=script&lang=js&"
export * from "./RichWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./RichWorkspace.vue?vue&type=style&index=0&id=7e06b1ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06b1ea",
  null
  
)

export default component.exports